import { Box, Link, Stack, Typography } from '@mui/material';

export function SupportFooter() {
  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        mt: 4,
        px: { xs: 2, md: 3 },
        py: 2.5,
      }}
    >
      <Stack spacing={0.5}>
        <Typography color="text.secondary" variant="body2">
          HESEDRA STP SRL · Vicolo del Lavatoio, 7 · 33170 Pordenone (PN) · P. IVA 01833140930
        </Typography>
        <Typography color="text.secondary" variant="body2">
          Assistenza:{' '}
          <Link href="mailto:servizioclienti@hesedra.com">servizioclienti@hesedra.com</Link>
          {' · '}Alfa tecnica ad accesso su invito
        </Typography>
      </Stack>
    </Box>
  );
}
